export const settingsIsReady = state => state.app.settingsIsReady
export const notifyIsReady = state => state.app.notifyIsReady
export const getTranslationsReady = state => state.app.translationsReady
export const hasError = state => state.app.error === true
export const getErrorMessage = state => state.app.errorMessage
export const getMainMenuItems = state => state.app.mainMenu
export const isLoggedIn = state => state.app.isLoggedIn
export const dvrModuleEnabled = state => state.app.modules.dvr === true
export const getToast = state => {
  if (!state.app.toastMessage) {
    return null
  } else {
    return {
      message: state.app.toastMessage,
      type: state.app.toastType
    }
  }
}
export const getPlayerTimeout = state => state.app.playerTimeout
export const getAppName = state => state.app.appName
export const getAppRoot = state => state.app.appRoot
export const getAllowYouTube = state => state.app.allowYouTube
export const getAvailableLanguages = state => state.app.availableLanguages
export const selectCheckoutModuleEnabled = state => state.app.modules.checkout !== false
export const getGlobalMessage = state => state.app.globalMessage
export const selectRadioModuleEnabled = state => state.app.modules.radio !== false
export const selectForceLogin = state => state.app.forceLogin
export const selectRemoveRegister = state => state.app.removeRegister
export const getPreviewDuration = state => state.app.previewDuration
export const getPreviewTriggerLength = state => state.app.previewTriggerLength
export const getTagManagerId = state => state.app.tagManagerId
export const getAnalyticsInterval = state => state.app.analyticsInterval
export const getAppBundleTemplate = state => state.app.appBundleTemplate

// privacy policy
export const getPrivacyPolicyReady = state => state.app.privacyPolicyReady
export const getPrivacyPolicyError = state => state.app.privacyPolicyError
export const getPrivacyPolicyContent = state => state.app.privacyPolicyContent

// default route
export const getDefaultRoute = state => state.app.defaultRoute
